import { create } from 'zustand'

import type { MeasurementWidget } from '@/integrations/betrakta/widgets'

type MeasurementStore = {
  dimensionsMM: {
    d: number
    dExtended: null | number
    h: number
    hExtended: null | number
    w: number
    wExtended: null | number
  }
  isVisible: boolean
  widget?: MeasurementWidget
}
const initialValues = {
  dimensionsMM: { d: 0, dExtended: null, h: 0, hExtended: null, w: 0, wExtended: null },
  isVisible: true,
  widget: undefined,
} as const

export const useMeasurementStore = create<MeasurementStore>(() => ({
  ...initialValues,
}))
